import Markdown from "markdown-to-jsx";
import Modal from "../Modal/Modal";
import classes from "./BrandIndexBreakups.module.css";

export default function BaseResponsesModal({ open, title, content, onClose }) {
  return (
    <Modal
      open={open}
      handleClose={onClose}
      title={title}
      width={800}
    >
      <div className={classes.info_modal_content}>
        <Markdown>{content || ""}</Markdown>
      </div>
    </Modal>
  );
}
